import {IMultiOccurrence, IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemSautDeLigneClass} from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IMenuItemActionClass} from "../../../../../core/services/menu/menu-item-action.service";
import {IEcranDetailsResourcesEntite} from '../../../../../core/resources/ecran-details.resource';

interface IPageMc0175 {
    valeursEcran: any;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
}
/* @ngInject */
export default function Mc0175Controller(Formulaire: IFormulaireClass,
                                         ecranDetails: IEcranDetailsResourcesEntite,
                                         Menu: IMenuClass,
                                         MenuItemAction: IMenuItemActionClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {
    const vm: IPageMc0175 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        actions: new Menu([

            new MenuItemAction(
                'LBL_BTN_DETRUIRE',
                'BOUDET',
                () => ({}),
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    successAction: () => {
                        vm.multiOccurrence.fetchDataList();
                    },
                    saveFirst: true,
                    messageConfirmation: 'BOUDET_CONFIRM'
                }
            )

        ]),
        fonctions: {
            importation: true
        },
        colonnesVisibles: [
            //  Attention à l'ordre des champs
            {nom: 'cnvnumlig', largeur: 100},
            {nom: 'cnvcha1', largeur: 120},
            {nom: 'cnvcha2', largeur: 100},
            {nom: 'cnvcha3', largeur: 300},
            {nom: 'cnvcha4', largeur: 300},
            {nom: 'cnvcha5', largeur: 100},
            {nom: 'cnvcha6', largeur: 100},
            {nom: 'cnvcha7', largeur: 200},
            {nom: 'cnvcha8', largeur: 150},
            {nom: 'cnvcha9', largeur: 100},
            {nom: 'cnvcha10', largeur: 100},
            {nom: 'cnvcha11', largeur: 100},
            {nom: 'cnvcha12', largeur: 150},
            {nom: 'cnvcha13', largeur: 150},
            {nom: 'cnvcha14', largeur: 300},
            {nom: 'cnvcha15', largeur: 100},
            {nom: 'cnvcha18', largeur: 100},  // 18 à 26
            {nom: 'cnvcha19', largeur: 100},
            {nom: 'cnvcha20', largeur: 260},
            {nom: 'cnvcha21', largeur: 200},
            {nom: 'cnvcha22', largeur: 200},
            {nom: 'cnvcha23', largeur: 100},
            {nom: 'cnvcha24', largeur: 100},
            {nom: 'cnvcha25', largeur: 100},
            {nom: 'cnvcha26', largeur: 130},
            {nom: 'cnvcha44', largeur: 100},  // 44
            {nom: 'cnvcha27', largeur: 100},
            {nom: 'cnvcha45', largeur: 100},  // 45
            {nom: 'cnvcha28', largeur: 130},
            {nom: 'cnvcha29', largeur: 360},
            {nom: 'cnvcha32', largeur: 170},  // 32 à 41
            {nom: 'cnvcha33', largeur: 100},
            {nom: 'cnvcha34', largeur: 100},
            {nom: 'cnvcha35', largeur: 80},
            {nom: 'cnvcha36', largeur: 80},
            {nom: 'cnvcha37', largeur: 80},
            {nom: 'cnvcha38', largeur: 80},
            {nom: 'cnvcha39', largeur: 80},
            {nom: 'cnvcha40', largeur: 100},
            {nom: 'cnvcha41', largeur: 100},
            {nom: 'cnvcha43', largeur: 150}, // 43
            {nom: 'cnvcha16', largeur: 360}, // 16 et 17
            {nom: 'cnvcha17', largeur: 170},
            {nom: 'cnvcha30', largeur: 150}, // 30 et 31
            {nom: 'cnvcha31', largeur: 100},
            {nom: 'cnvcha55', largeur: 100}, // 55 et 56
            {nom: 'cnvcha56', largeur: 100}

        ],
        formulaire: new Formulaire([
            new FormulaireItem('cnvnumlig', {largeur: 20}),
            new FormulaireItem('cnvcha1',  {largeur: 20}),
            new FormulaireItem('cnvcha2',  {largeur: 20}),
            new FormulaireItem('cnvcha3',  {largeur: 20}),
            new FormulaireItem('cnvcha4',  {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha5',  {largeur: 20}),
            new FormulaireItem('cnvcha6',  {largeur: 20}),
            new FormulaireItem('cnvcha7',  {largeur: 20}),
            new FormulaireItem('cnvcha8',  {largeur: 20}),
            new FormulaireItem('cnvcha9',  {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha10', {largeur: 20}),
            new FormulaireItem('cnvcha11', {largeur: 20}),
            new FormulaireItem('cnvcha12', {largeur: 20}),
            new FormulaireItem('cnvcha13', {largeur: 20}),
            new FormulaireItem('cnvcha14', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha15', {largeur: 20}),
            new FormulaireItem('cnvcha18', {largeur: 20}),  // 18 à 26
            new FormulaireItem('cnvcha19', {largeur: 20}),
            new FormulaireItem('cnvcha20', {largeur: 20}),
            new FormulaireItem('cnvcha21', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha22', {largeur: 20}),
            new FormulaireItem('cnvcha23', {largeur: 20}),
            new FormulaireItem('cnvcha24', {largeur: 20}),
            new FormulaireItem('cnvcha25', {largeur: 20}),
            new FormulaireItem('cnvcha26', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha44', {largeur: 20}),  // 44
            new FormulaireItem('cnvcha27', {largeur: 20}),
            new FormulaireItem('cnvcha45', {largeur: 20}),  // 45
            new FormulaireItem('cnvcha28', {largeur: 20}),
            new FormulaireItem('cnvcha29', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha32', {largeur: 20}),  // 32 à 41
            new FormulaireItem('cnvcha33', {largeur: 20}),
            new FormulaireItem('cnvcha34', {largeur: 20}),
            new FormulaireItem('cnvcha35', {largeur: 20}),
            new FormulaireItem('cnvcha36', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha37', {largeur: 20}),
            new FormulaireItem('cnvcha38', {largeur: 20}),
            new FormulaireItem('cnvcha39', {largeur: 20}),
            new FormulaireItem('cnvcha40', {largeur: 20}),
            new FormulaireItem('cnvcha41', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha43', {largeur: 20}), // 43
            new FormulaireItem('cnvcha16', {largeur: 20}), // 16 et 17
            new FormulaireItem('cnvcha17', {largeur: 20}),
            new FormulaireItem('cnvcha30', {largeur: 20}), // 30 et 31
            new FormulaireItem('cnvcha31', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha55', {largeur: 20}), // 55 et 56
            new FormulaireItem('cnvcha56', {largeur: 20})
        ])
    };
}
